import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const pagesLandingPublisher: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/pages-landing-publisher`),
};

export default pagesLandingPublisher;
